import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import {AlertSchema} from '../../../../api/DBSchema/Alert';
import mailIcon from '../../../../assets/images/mail.png';
import clipboardIcon from '../../../../assets/images/clipboard.png';
import SMCLink from '../../../../components/Simple/SMCLink';
import AlertEditorModal from '../../../PopupPages/AlertEditorModal';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import {isUserAdminSelector} from '../../../../store/selectors/user.selectors';

const pageSchema = PortalSettingsGetSchema.pages.customAlerts;
const pageId = pageSchema.pageId;

function PortalSettingsCustomAlerts({
    portalSettingsObject,
    setPortalSettingsData,
    isUserAdmin
}) {
    const { t } = useTranslation();

    const pageData  = portalSettingsObject[pageId];
    const alertList = pageData[pageSchema.alertList];

    const [isAlertEditorOpen, setIsAlertEditorOpen] = useState(false);
    const [currentlyEditedAlert, setCurrentlyEditedAlert] = useState(null);
    const [currentlyEditedAlertIndex, setCurrentlyEditedAlertIndex] = useState(null);
    const [selectedAlerts, setSelectedAlerts] = useState([]);

    const alertEditorOnSuccess = useCallback((val) => {
        const alertListCopy = [...alertList];
        if (currentlyEditedAlert) {
            alertListCopy[currentlyEditedAlertIndex] = val;
            setCurrentlyEditedAlert(null);
            setCurrentlyEditedAlertIndex(null);
        } else {
            alertListCopy.push(val);
        }
        setPortalSettingsData([pageId, pageSchema.alertList], alertListCopy);
        setIsAlertEditorOpen(false);
    }, [alertList, currentlyEditedAlert, currentlyEditedAlertIndex, setPortalSettingsData]);

    const alertEditorOnClose = useCallback(() => {
        setCurrentlyEditedAlert(null);
        setCurrentlyEditedAlertIndex(null);
        setIsAlertEditorOpen(false);
    }, []);

    const deleteSelectedAlerts = useCallback(() => {
        if (selectedAlerts.length) {
            const newAlertList = alertList.filter((obj, index) => {
                return !selectedAlerts.includes(index);
            });
            setPortalSettingsData([pageId, pageSchema.alertList], newAlertList);
            setSelectedAlerts([]);
        }
    }, [alertList, selectedAlerts, setPortalSettingsData]);

    const NameCell = React.memo(({value, object, index}) => (
        <SMCLink
            inline
            onClick={() => {
                setCurrentlyEditedAlert(object);
                setCurrentlyEditedAlertIndex(index);
                setIsAlertEditorOpen(true);
            }}
        >
            {value}
        </SMCLink>
    ));
    const ActionCell = React.memo(({value}) => (
        value ? (<img src={mailIcon} alt="mail" />) : (<img src={clipboardIcon} alt="log" />)
    ));
    const EnabledCell = React.memo(({value}) => (
        value ? (<SMCIcon icon="greenCheck" />) : (<SMCIcon icon="redX" />)
    ));

    return (
        <EditorLayout lineHeight="32px">
            <RowLayout>
                <SMCButton variant="ghost" icon="new" onClick={() => setIsAlertEditorOpen(true)}>{t('SMC_GEN_NEW')}</SMCButton>
                <SMCButton variant="ghost" icon="delete" onClick={deleteSelectedAlerts}>{t('SMC_GEN_DELETE')}</SMCButton>
            </RowLayout>
            <SMCTable
                columns={[
                    { id: 'name',        header: t('SMP.NAME'),        width: 100, accessor: AlertSchema.name,                                                    Cell: NameCell    },
                    { id: 'description', header: t('SMP.DESCRIPTION'), width: 100, accessor: AlertSchema.description                                                                },
                    { id: 'action',      header: t('SMP.ACTION'),      width: 100, accessor: AlertSchema.isSendMail,                             align: 'center', Cell: ActionCell  },
                    { id: 'enabled',     header: t('SMP.ENABLED'),     width: 100, accessor: [AlertSchema.data, AlertSchema.dataSchema.enabled], align: 'center', Cell: EnabledCell }
                ]}
                content={alertList}
                selectedObjects={selectedAlerts}
                setSelectedObjects={setSelectedAlerts}
                rowIdSelector={(obj, index) => index}
                hasCheckAll={true}
            />
            {/* Popup windows */}
            <AlertEditorModal
                isOpen={isAlertEditorOpen}
                onRequestClose={alertEditorOnClose}
                defaultObject={currentlyEditedAlert}
                onSuccess={alertEditorOnSuccess}
                isGlobal={false}
                hasAdministratorsTab={isUserAdmin}
            />
        </EditorLayout>
    )
}

const mapStateToProps = state => ({
    isUserAdmin: isUserAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PortalSettingsCustomAlerts);